import React from 'react';
import PropTypes from 'prop-types';
import CancelledTag from '@/pages/_components/CancelledTag';
import CompletedTag from '@/pages/_components/CompletedTag';
import ExpiredTag from '@/pages/_components/ExpiredTag';
import { isExpired } from '@/utils/dateTimeUtils';

export default function StatusTags(props) {
  const { offer } = props;

  if (offer.data.cancelled) {
    return (
      <div className="flex space-x-4">
        <CancelledTag resource={offer}/>
      </div>
    );
  }

  if (offer.data.completed) {
    return (
      <div className="flex space-x-4">
        <CompletedTag resource={offer}/>
      </div>
    );
  }

  if (isExpired(offer.data.endDate)) {
    return (
      <div className="flex space-x-4">
        <ExpiredTag resource={offer}/>
      </div>
    );
  }

  return null;
}

StatusTags.propTypes = {
  offer: PropTypes.shape({
    data: PropTypes.shape({
      cancelled: PropTypes.bool,
      completed: PropTypes.bool,
      endDate: PropTypes.string
    })
  }).isRequired
};
